module.exports = __webpack_public_path__ + "static/media/Heather Gong.7f4471e2.png";